import React, { useEffect, useState } from 'react'
import { Modal, Button, Row, Col, Skeleton } from 'antd'
import TableGrid from '../../../shared/TableGrid/TableGrid'
import { DownloadOutlined } from '@ant-design/icons'
import './defineWacModal.scss'
import {
  ModalColumnsConfig,
  copyColumnsContractComparisonWac
} from '../../../constants/contractComparisonConstant'
import CopyToExcel from '../../../shared/copyToExcel/CopyToExcel'
import { useSelector, useDispatch } from 'react-redux'
import { updateContractComparisonWACData } from '../../../reducer/contractComparison/contractComparisonSlice'
import { useGlobalNotification } from '../../../utils/notificationProvider'

const DefineWacModal = ({ isVisible, handleCancel, handleSave }) => {
  const dispatch = useDispatch()
  const [columnConfig, setColumnConfig] = useState(ModalColumnsConfig)
  const [filterWac, setFilterWac] = useState(null)
  const [sorterWac, setSorterWac] = useState(null)
  // const [filtersValues, setFiltersValues] = useState({
  //   product: [],
  //   market: [],
  //   manufacturer: [],
  // });
  const [tableParamsContractComparisonWac, settableParamsContractComparisonWac] = useState({
    pagination: {
      current: 1,
      pageSize: 5
      // total: 50,
    }
  })

  // below should be removed and moved to a resuable component and functions
  const [loading, setLoading] = useState(true)
  const [isExport, setIsExport] = useState(false)

  const pushNotification = useGlobalNotification()

  const contractComparisonWACData = useSelector(
    (state) => state.ContractComparison.contractComparisonWACData
  )

  useEffect(() => {
    if (contractComparisonWACData.length > 0) {
      setLoading(false)
    }
  }, [contractComparisonWACData])

  const disptachTableParam = (pagination) => {
    settableParamsContractComparisonWac({
      ...tableParamsContractComparisonWac,
      pagination: {
        ...tableParamsContractComparisonWac.pagination,
        current: pagination.current
      }
    })
  }

  const handleCopySuccess = () => {
    pushNotification('success', 'Data copied successfully!', 'WAC data copied successfully.', 3)
  }

  const handleCopyError = () => {
    pushNotification('error', 'Copy failed!', 'There was an error copying the data.', 3)
  }

  const handleCustomWACChange = (newData, row) => {
    const index = newData.findIndex((item) => row.key === item.key)
    if (index !== -1) {
      const item = newData[index]
      const updatedCustomWAC = parseFloat(row.custom_wac).toFixed(2)
      newData.splice(index, 1, {
        ...item
        //custom_wac: updatedCustomWAC,
      })
      dispatch(updateContractComparisonWACData(newData))
    } else {
      console.error('Record not found')
    }
  }

  const handleCancelContractComparisonWAC = () => {
    const resetData = contractComparisonWACData.map((item) => ({
      ...item,
      custom_wac: item.custom_wac_cancel
    }))
    dispatch(updateContractComparisonWACData(resetData))
    handleCancel()
  }

  const updatedData = contractComparisonWACData.map((item, index) => ({
    ...item,
    key: item.product_id // Adding the key property
  }))

  const getCopyDate = (copyDate) => {
    const date = new Date(copyDate)

    const day = date.getDate()
    const month = date.toLocaleString('en-GB', { month: 'short' })
    const year = date.getFullYear()

    const formatted = `${day} ${month}, ${year}`
    return formatted
  }

  return (
    <Modal
      title="Define Custom WAC"
      open={isVisible}
      onCancel={handleCancelContractComparisonWAC}
      footer={[
        <div
          style={{
            padding: '16px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'flex-end'
          }}
        >
          <Button key="cancel" onClick={handleCancelContractComparisonWAC}>
            Cancel
          </Button>

          <Button key="save" type="primary" onClick={handleSave}>
            Save
          </Button>
        </div>
      ]}
      style={{ minWidth: '1200px', maxHeight: '90vh' }}
      centered
      className="custom-modal"
    >
      <>
        <Skeleton active loading={loading} paragraph={{ rows: 8 }}>
          <div className="modal-content-wrapper">
            <div className="define-wac-modal-Header">
              <Row>
                <Col style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <CopyToExcel
                    columns={copyColumnsContractComparisonWac}
                    data={contractComparisonWACData.map((val) => ({
                      ...val,
                      effective_date: getCopyDate(String(val?.effective_date)?.split('T')[0])
                    }))}
                    filters={undefined}
                    sorter={sorterWac}
                    onCopySuccess={handleCopySuccess}
                    onCopyError={handleCopyError}
                  />
                </Col>
              </Row>
            </div>
            <div className="define-Wac-Modal-Table" style={{ padding: '16px' }}>
              <TableGrid
                // scroll1={{
                //     y: 270,
                //     // x:"auto"
                //   }}
                columnsConfig={columnConfig}
                dataSource={updatedData}
                dispatchUpdateDataSource={handleCustomWACChange}
                disptachTableParam={disptachTableParam}
                onChange={(pagination, filters, sorter) => {
                  setFilterWac(filters)
                  setSorterWac(sorter)
                }}
                pagination={{
                  ...tableParamsContractComparisonWac.pagination,
                  showSizeChanger: false
                }}
                // pagination={false}
              />
            </div>
          </div>
        </Skeleton>
      </>
    </Modal>
  )
}

export default DefineWacModal
